import React, { useEffect, useRef, useState } from 'react'
// types
import { PageHeaderProps } from './header.types'
import { Link } from 'react-router-dom'
const PageHeader = (props: PageHeaderProps) => {
  const [pageheaderHeight, setpageHeaderHeight] = useState<number>(0)
  function handleWindowResize() {
    const headerElement = document.querySelector('[data-pageheader="true"]')
    if (headerElement instanceof HTMLElement) {
      const height = headerElement.offsetHeight
      setpageHeaderHeight(height)
    }
  }
  useEffect(() => {
    // Get header height based on attribute or tag
    handleWindowResize()
    document.title=props?.name
    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])
  useEffect(() => {
    // Update CSS variable when headerHeight changes
    document.documentElement.style.setProperty('--pageheader-height', `${pageheaderHeight}px`)
  }, [pageheaderHeight])
  const [count, setCount] = useState('')
  useEffect(() => {
    if (props?.count < 10) {
      setCount('0' + props?.count)
    } else {
      setCount(props?.count)
    }
  }, [props])
  const tittleRef: any = useRef(null)
  const handleClick = (event: MouseEvent) => {
    const activeElement = document.querySelector('.link.active.active')
    if (activeElement && activeElement === event.target && tittleRef.current) {
      tittleRef.current.focus()
    }
  }
  useEffect(() => {
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])
  return (
    <div data-pageheader="true" className={`main-page-header ${props?.pageHeaderclassName}`}>
      <div className="d-flex align-items-center py-1">
        {props?.name && <div tabIndex={0} ref={tittleRef} aria-describedby='pagetitles' id="pagetitles" className='d-flex align-items-center sora-bold text-color-12 font-18'>
          {props?.icon && <span className={props.icon}></span>}
          {props?.appicon && <Link to={props?.urlback || '/'} aria-label='Navigate back to home' className='pe-2'><span className='icon-rb-arrow-left-thick font-14 darktext'></span></Link>}
          <h1 className='sora-bold text-color-12 font-16' dangerouslySetInnerHTML={{ __html: props?.name }} />
          {props?.count > 0 && <span className="badge bgcolor-primary border-radius-3 px-2 py-1 whitetext ms-1" aria-label={count}> {count}</span>}
        </div>
        }
        <div>
        {props?.toolTip &&
          <>
            {props.toolTip}
          </>
        }
        </div>
      </div>
      <div className='d-flex flex-column flex-row-sm align-items-center-md  maxfitcontent-sm ms-sm-auto extras-div'>
        <div className="d-flex flex-wrap flex-column flex-row-sm justify-content-end-sm gap-2">
          {props.extras &&
            <>
              {props.extras}
            </>
          }
        </div>
      </div>
    </div>
  )
}
export default PageHeader
